import { render, staticRenderFns } from "./CardSummaryOrderSend.vue?vue&type=template&id=6de5afc2&"
import script from "./CardSummaryOrderSend.vue?vue&type=script&lang=js&"
export * from "./CardSummaryOrderSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports